import { Component, OnInit, Inject, ViewEncapsulation, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AppService } from "src/_services/app.service";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import * as moment from "moment";
import { MatDatepickerInputEvent } from "@angular/material";
import { FormControl, FormGroup, Validators } from "@angular/forms";

type mapEvents = {
    geniePremiumEventId: string;
    geniePremiumEventName: string;
    geniePremiumSportId: string;
    mappedEventId: string;
    mappedEventName: string;
    openDate: number;
};

export interface DialogData {
    eventName: string;
    sportId: string;
    eventId: string;
    startDate: number;
    endDate: number;
    openDate: string;
}

@Component({
    selector: "app-genie-premium-mapping",
    templateUrl: "./genie-premium-mapping.component.html",
    styleUrls: ["./genie-premium-mapping.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class GeniePremiumMappingComponent implements OnInit {
    showAlert = false;
    sportId = new FormControl([]);
    sport = "";
    sportsList: any[] = [];
    searchEvent = "";
    searchKey = "";

    ProviderId: string = "GeniusPremium";
    unMappedEventList = [];
    orgUnMappedEventList = [];

    showFilterInput: boolean = false;
    start: any;
    end: any;

    selected: any = {
        startDate: null,
        endDate: null,
    };
    sportSettings: any = {};

    orgMappedEvents: mapEvents[] = [];
    mappedEvents: mapEvents[] = [];

    UnMappedTableHeders: string[] = [
        "Open Date",
        "Sport",
        "Event Id",
        "Event Name",
        "Competition Id",
        "Competition Name",
        "Action",
        "Flag"
    ];

    mappedEventsTableHeaders: string[] = [
        "Open Date",
        "Genie Premium EventId",
        "Genie Premium EventName",
        "Mapped EventId",
        "Mapped EventName",
        "Actions",
    ];
    startOfDay = moment().subtract(1, "days").startOf("day");
    endOfDay = moment().subtract(1, "days").endOf("day");
    ranges: any = {
        Today: [moment().startOf("day"), moment()],
        Yesterday: [
            moment(this.startOfDay),
            moment(this.endOfDay),
        ],
        "Last 7 Days": [
            moment(moment().subtract(6, "days").startOf("day")),
            moment(),
        ],
        "Last 30 Days": [
            moment(moment().subtract(29, "days").startOf("day")),
            moment(),
        ],
        "This Month": [moment().startOf("month"), moment()],
        "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
        ],
    };

    constructor(
        private appService: AppService,
        private router: Router,
        private dialog: MatDialog,
        private activetedRoute: ActivatedRoute,
    ) { }

    ngOnInit() {
        this.sportSettings = {
            singleSelection: true,
            idField: "SportId",
            textField: "SportName",
            selectAllText: "Select All",
            unSelectAllText: "UnSelect All",
            itemsShowLimit: 1,
            allowSearchFilter: true,
        };
        this.selected.startDate = moment().startOf("day");
        this.selected.endDate = moment().add(2, "days").endOf("day");
        this.activetedRoute.queryParams.subscribe((params) => {
            this.sport = params["sportId"];
            this.start = params["startDate"];
            this.end = params["endDate"];
        });
        if (this.start !== undefined && this.end !== undefined) {
            this.selected.startDate = moment(parseInt(this.start))
            this.selected.endDate = moment(parseInt(this.end))
        }
        this.getSportsByProvider(this.ProviderId);
    }

    onFilterChange() {
        this.getMapEvents();
        this.getUnMappedEvents();
    }

    onDateChangeHandler = (event: MatDatepickerInputEvent<Date>) => {
        this.selected = event;
        if (this.selected.endDate.diff(this.selected.startDate, "days") > 4) {
            this.showAlert = true;
            this.selected.startDate = moment().startOf("day");
            this.selected.endDate = moment().add(2, "days").endOf("day");
            setTimeout(() => {
                this.showAlert = false;
            }, 7000);
        }
    };

    getUnMappedEvents() {
        try {
            if (this.sportId.value && this.sportId.value.length > 0) {
                const payload = {
                    providerId: this.ProviderId,
                    sportId: this.sportId.value[0].SportId,
                    startDate: moment(this.selected.startDate).unix(),
                    endDate: moment(this.selected.endDate).unix(),
                }
                this.appService
                    .getGeniePremiumUnMappedEvents(
                        payload
                    )
                    .subscribe((res) => {
                        this.unMappedEventList = res.events;
                        this.orgUnMappedEventList = res.events;
                    });
            }
        } catch (err) { }
    }

    convertDate(timeInSeconds) {
        const date = new Date(timeInSeconds).getDate();
        const month = new Date(timeInSeconds).getMonth() + 1;
        const year = new Date(timeInSeconds).getFullYear();
        const hour = new Date(timeInSeconds).toTimeString().slice(0, 9);

        return date + "/" + month + "/" + year + " " + hour;
    }

    getSportsByProvider(providerId) {
        try {
            this.appService.getSportForBetList(providerId).subscribe((res) => {
                if (res.status === "RS_OK") {
                    this.sportsList = res.sports;
                    if (this.sportsList && this.sportsList.length > 0) {
                        // Set first sport if no sport is selected from query params
                        this.sportId.setValue([this.sportsList[0]]);
                        // this.onFilterChange();
                    }
                } else {
                    this.appService.openErrorBar(res.errorDescription);
                }
            });
        } catch (err) { }
    }

    getSportName(value) {
        let response = this.sportsList.find(sport => sport.SportId === value)
        return response ? response.SportName : "";
    }

    setShowOptions(val) {
        if (val.index === 1) {
            this.showFilterInput = true;
        } else {
            this.showFilterInput = false;
        }
    }

    searchHandlerChange() {
        if (this.searchKey.length >= 1) {
            this.unMappedEventList = this.orgUnMappedEventList.filter((event) => {
                if (
                    event.eventId
                        .toLowerCase()
                        .includes(this.searchKey.toLocaleLowerCase()) ||
                    event.eventName
                        .toLocaleLowerCase()
                        .includes(this.searchKey.toLocaleLowerCase())
                ) {
                    return event;
                }
            });
        } else {
            this.unMappedEventList = this.orgUnMappedEventList;
        }
    }

    onBFInputChange() {
        if (this.searchEvent.length >= 1) {
            this.mappedEvents = this.orgMappedEvents.filter((event) => {
                if (
                    (event.geniePremiumEventName &&
                        event.geniePremiumEventName
                            .toLowerCase()
                            .includes(this.searchEvent.toLocaleLowerCase())) ||
                    (event.geniePremiumEventId &&
                        event.geniePremiumEventId
                            .toLowerCase()
                            .includes(this.searchEvent.toLocaleLowerCase())) ||
                    (event.mappedEventName &&
                        event.mappedEventName
                            .toLowerCase()
                            .includes(this.searchEvent.toLocaleLowerCase())) ||
                    (event.mappedEventId &&
                        event.mappedEventId
                            .toLowerCase()
                            .includes(this.searchEvent.toLocaleLowerCase()))
                ) {
                    return event;
                }
            });
        } else {
            this.mappedEvents = this.orgMappedEvents;
        }
    }

    getMapEvents() {
        if (this.sportId.value && this.sportId.value.length > 0) {
            try {
                const payload = {
                    providerId: this.ProviderId,
                    sportId: this.sportId.value[0].SportId,
                    startDate: moment(this.selected.startDate).unix(),
                    endDate: moment(this.selected.endDate).unix(),
                }
                this.appService
                    .getGeniePremiumMappedEvents(payload)
                    .subscribe((res) => {
                        if (res.status === "RS_OK") {
                            this.mappedEvents = res.geniePremiumMaps || [];
                            this.orgMappedEvents = res.geniePremiumMaps || [];
                        } else {
                            this.appService.openErrorBar(res.errorDescription);
                        }
                    });
            } catch (err) { }
        }
    }

    openGenieEventsModal(event) {
        const dialogRef = this.dialog.open(GenieEventMappingModal, {
            backdropClass: "backdropBackground",
            hasBackdrop: true,
            data: {
                eventName: event.eventName,
                sportId: event.sportId,
                eventId: event.eventId,
                startDate: this.selected.startDate,
                endDate: this.selected.endDate,
                openDate: event.openDate,
            },
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.getUnMappedEvents();
                this.getMapEvents();
            }
        });
    }

    flagEvent(event) {
        const payload = {
            eventId: event.eventId,
            sportId: event.sportId,
            providerId: event.providerName,
            flag: !(event.map_flag),
        };
        try {
            this.appService.flagEvent(payload).subscribe((res) => {
                if (res.status === "RS_OK") {
                    this.appService.openSuccessBar(res.errorDescription);
                    this.getUnMappedEvents();
                } else {
                    this.appService.openErrorBar(res.errorDescription);
                }
            });
        } catch (err) { }
    }

    openEditModal(event) {
        const dialogRef = this.dialog.open(GenieEditMappingModal, {
            backdropClass: "backdropBackground",
            hasBackdrop: true,
            data: {
                id: event.id,
                geniePremiumEventName: event.geniePremiumEventName,
                geniePremiumEventId: event.geniePremiumEventId,
                geniePremiumSportId: event.geniePremiumSportId,
                mappedEventId: event.mappedEventId,
                mappedEventName: event.mappedEventName,
                openDate: event.openDate,
                createdAt: event.createdAt
            },
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.getMapEvents();
            }
        });
    }

    unMapEvent(event) {
        const payload = {
            geniePremiumEventId: event.geniePremiumEventId,
        };
        try {
            this.appService.unmapGeniePremiumEvent(payload).subscribe((res) => {
                if (res.status === "RS_OK") {
                    this.appService.openSuccessBar("Unmapped");
                    this.getMapEvents();
                    this.getUnMappedEvents();
                } else {
                    this.appService.openErrorBar(res.errorDescription);
                }
            });
        } catch (err) { }
    }
}

@Component({
    selector: "GenieEventMappingModal",
    templateUrl: "./genie-event-mapping-modal.html",
    styleUrls: ["./genie-premium-mapping.component.scss"],
})
export class GenieEventMappingModal {
    filteredGenieEvents = [];
    genieEvents;
    searchEvent = "";
    selectedEvent;
    ngOnInit() {
        this.getGenieEvents();
    }
    constructor(
        public dialogRef: MatDialogRef<GenieEventMappingModal>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        private appService: AppService,
        public router: Router,
    ) { }

    onChangeSearchInput() {
        if (this.searchEvent.length >= 1) {
            this.filteredGenieEvents = this.genieEvents.filter((event) => {
                if (
                    event.eventName
                        .toLowerCase()
                        .includes(this.searchEvent.toLocaleLowerCase()) ||
                    event.eventId
                        .toLocaleLowerCase()
                        .includes(this.searchEvent.toLocaleLowerCase())
                ) {
                    return event;
                }
            });
        } else {
            this.filteredGenieEvents = this.genieEvents;
        }
    }
    selectEventToMap(event) {
        this.selectedEvent = event;
    }
    getGenieEvents() {
        try {
            if (this.data.sportId) {
                const payload = {
                    providerId: "SportRadar",
                    sportId: this.data.sportId,
                    startDate: moment(this.data.startDate).unix(),
                    endDate: moment(this.data.endDate).unix(),
                };
                this.appService
                    .getGeniePremiumUnMappedEvents(payload)
                    .subscribe((res) => {
                        if (res.status === "RS_OK") {
                            this.genieEvents = res.events;
                            this.filteredGenieEvents = res.events;
                        }
                    });
            }
        } catch (err) { }
    }
    cancelMapping() {
        this.dialogRef.close();
    }

    mapTheEvent() {
        if (this.selectedEvent) {
            if (this.selectedEvent.eventId) {
                const payload = {
                    geniePremiumEventId: this.data.eventId,
                    mappedEventId: this.selectedEvent.eventId,
                    geniePremiumSportId: this.data.sportId,
                    geniePremiumEventName: this.data.eventName,
                    openDate: this.data.openDate,
                };
                try {
                    this.appService.addGeniePremiumEvent(payload).subscribe((res) => {
                        if (res.status === "RS_OK") {
                            this.appService.openSuccessBar("successfully");
                            this.dialogRef.close(true);
                        } else {
                            this.appService.openErrorBar(res.errorDescription);
                        }
                    });
                } catch (err) { }
            }
        }
    }

    convertDate(timeInSeconds) {
        const date = new Date(timeInSeconds).getDate();
        const month = new Date(timeInSeconds).getMonth() + 1;
        const year = new Date(timeInSeconds).getFullYear();
        const hour = new Date(timeInSeconds).toTimeString().slice(0, 9);

        return date + "/" + month + "/" + year + " " + hour;
    }

    onNoClick(): void {
        this.dialogRef.close();
    }
}

export interface EditDialogData {
    id: string;
    createdAt: number;
    geniePremiumSportId: string;
    geniePremiumEventId: string;
    geniePremiumEventName: string;
    mappedEventId: string;
    mappedEventName: string;
}

@Component({
    selector: "GenieEditMappingModal",
    templateUrl: "./genie-edit-mapping-modal.html",
    styleUrls: ["./genie-edit-mapping-modal.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class GenieEditMappingModal {
    mappingInfo: FormGroup;
    constructor(
        public dialogRef: MatDialogRef<GenieEditMappingModal>,
        @Inject(MAT_DIALOG_DATA) public data: EditDialogData,
        private appService: AppService,
        public router: Router,
    ) { }

    ngOnInit() {
        this.mappingInfo = new FormGroup({
            geniePremiumEventId: new FormControl(this.data.geniePremiumEventId, Validators.required),
            mappedEventId: new FormControl(this.data.mappedEventId, Validators.required),
        });
    }

    confirmMapEditing() {
        const payload = {
            id: this.data.id,
            createdAt: this.data.createdAt,
            sportId: this.data.geniePremiumSportId,
            geniePremiumEventId: this.mappingInfo.value.geniePremiumEventId,
            mappedEventId: this.mappingInfo.value.mappedEventId,
        };
        try {
            this.appService.editGeniePremiumMap(payload).subscribe((res) => {
                if (res.status === "RS_OK") {
                    this.appService.openSuccessBar("successfully");
                    this.dialogRef.close(true);
                } else {
                    this.appService.openErrorBar(res.errorDescription);
                    this.dialogRef.close();
                }
            });
        } catch (err) { }
    }

    onNoClick(): void {
        this.dialogRef.close();
    }
}
